/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {SiteModel} from './site-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {SiteAnalysisPageComponent} from './site-analysis-page.component';
import {SiteEditPageComponent} from './site-edit-page.component';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED, SiteAnalysisPageComponent, SiteEditPageComponent],
  selector: 'adn-site-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-site-edit-page leftPanel [state]="state"></adn-site-edit-page>
      <adn-site-analysis-page rightPanel [state]="state" [model]="state.model()" [isNew]="state.isNew()"></adn-site-analysis-page>
    </adn-two-panel-layout>
  `
})
export class SiteItemPageComponent {
  @Input() state: SignalAdminResourcePageState<SiteModel>;
}
